import React, { useState } from 'react'
import { firestore } from '../../../firebase';
import EditChoice from './EditChoice';

function SingleChoice({choice, isSubmitted, mode, quizId, questionId, correctAmount, setCorrectAmount, selected, setSelected}) {

    const [prevSelectedStatus, setPrevSelectedStatus] = useState(false);

    const [show, setShow] = useState(false);

    function choiceHandler(choice) {

        if (isSubmitted) {
            return
        }

        // If question has not been answered and is correct -- set correct amount to plus 1;
        if (!selected) {
            console.log("!selected")
            if (choice.is_correct) {
                setCorrectAmount(correctAmount+1);
                setPrevSelectedStatus(true)
            }
            // if question has been answered and not correct -- do nothing
        } else {
            if (choice.id === selected) {
                setCorrectAmount(correctAmount)
                setPrevSelectedStatus(true)
            } else {

                // If prev selected was incorrect
                if (!prevSelectedStatus) {
                    // Do not subtract amount
                    // if question has been answered and changed from correct to wrong
                    if (!choice.is_correct) {
                        setCorrectAmount(correctAmount);
                        setPrevSelectedStatus(false);
                    }
                    // if question has been answered and changes from wrong to correct
                    if (choice.is_correct) {
                        setCorrectAmount(correctAmount+1);  
                        setPrevSelectedStatus(true)            
                    }
                } else {
                    console.log("selected")
                    if (choice.is_correct) {
                        setCorrectAmount(correctAmount);
                        setPrevSelectedStatus(true)              
                    }
                    // if question has been answered and changed from correct to wrong
                    if (!choice.is_correct) {
                        setCorrectAmount(correctAmount-1);
                        setPrevSelectedStatus(false)
                    }
                }

            }

        }
        
        setSelected(choice.id);

    }

    async function deleteHandler(e, choiceId) {
        e.preventDefault();
        try {
            console.log(quizId, questionId, choiceId)
            const choiceRef = firestore.collection("quiz").doc(quizId).collection("questions").doc(questionId).collection("choices").doc(choiceId);
            choiceRef.delete();
        } catch (error) {
            console.log(error)
        }
    }

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }

    return (
        <div 
        className="row"
        >
            <div
                style={{cursor: "pointer"}} 
                className={choice.id === selected ? "text-dark py-1 col-10" : " py-1 col-10"} 
                onClick={() => choiceHandler(choice)} 
            >
                <i className={choice.id === selected ? "fas fa-check-circle text-success" : "far fa-circle text-light"}></i> 
                <span className={isSubmitted && choice.is_correct ? "text-success" : isSubmitted && choice.id === selected && !choice.is_correct && "text-danger"}> {choice.choice} </span>
            </div>
            <div className="col-2">
                {mode === "edit" && 
                <span className="float-right">
                    <i onClick={toggle} className={show ? "fas fa-window-close" : "fas fa-edit text-primary"}></i>
                    <i onClick={(e) => deleteHandler(e, choice.id)} className="fas fa-trash text-danger pl-1"></i> 
                </span>}
            </div>
            {show && <EditChoice choice={choice} quizId={quizId} questionId={questionId} />}
        </div>
    )
}
export default SingleChoice